<div class="modal-body width-600 height-600">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getResource('HeaderText')}}
    </span>
    <div class="content">
      <exg-data-list [allowSingleSelection]="false" [displayState]="0"
                     [rowSource]="data"
                     selectKey="lnkID">
        <ng-template #rowTemplate let-row>
          <div class="grid" style="padding:0.5rem">
            <div>
              <div class="typo-small grid cols-2">
                <div>{{row.lnkCRD | excDate:'Globals.DateTimeFormatShort'}}</div>
                <div class="typo-right">{{row.lnkCRU}}</div>
              </div>
              <div><strong>{{row.lnkName}}</strong></div>
            </div>
          </div>
        </ng-template>
      </exg-data-list>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Close')}}
      </button>
    </div>
  </div>
</div>
